import { createContext as e } from "react";
const o = e(null), l = e(null);
export {
  l as GlobalHeaderv2DevContext,
  o as GlobalHeaderv2PrivateContext
};
